enum AnnotationSquigglyDialogFields {
	CREATOR = "creator",
	SUBJECT = "subject",
	CONTENTS = "contents",
	INTENTS = "intents",
	COLOR = "color",
	OPACITY = "opacity",
}

export default AnnotationSquigglyDialogFields;